import React from "react";
import Sidebar from "../../../Components/Sidebar/Sidebar";
import { HrSideBarItems } from "./Routes";

const Navbar = () => {
  return <Sidebar sideBarItems={HrSideBarItems} />;
};

export default Navbar;
